import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import bottlesReducer from './slices/bottlesSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    bottles: bottlesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;